import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import _ from 'lodash';

import { resetFilterValue, setFilterValue } from 'store/filters/actions';
import { getFilterValueSelector } from 'store/filters/selectors';

const useFilter = ({
  filtersGroupId,
  filterId,
  shouldResetValueOnUnmount = false,
  defaultValue = null,
} = {}) => {
  const dispatch = useDispatch();
  const currentFilterValue = useSelector(getFilterValueSelector({ filtersGroupId, filterId }));

  const onChangeFilterValue = useCallback(
    newValue => {
      dispatch(setFilterValue({ filtersGroupId, filterId, value: newValue }));
    },
    [dispatch, filterId, filtersGroupId],
  );

  useEffect(() => {
    if (_.isNil(defaultValue)) {
      return;
    }

    onChangeFilterValue(defaultValue);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!shouldResetValueOnUnmount) {
      return;
    }

    return () => {
      dispatch(resetFilterValue({ filtersGroupId, filterId }));
    };
  }, [dispatch, filterId, filtersGroupId, shouldResetValueOnUnmount]);

  return { filterValues: currentFilterValue, setFilterValue: onChangeFilterValue };
};

export default useFilter;
